export default "__VITE_ASSET__D8IPn52u__"